import App from "./App";
import ReactDOM from "react-dom";

ReactDOM.render(<App />,document.getElementById('root'));